<div class="title-divider-print-buttons mt-md-2">
  <h1 translate>unsupported.title</h1>
</div>

<p class="lead">
  <span translate>unsupported.text</span><br/>
  <span translate>security.adminHint</span>
</p>

<span translate>security.actionUrl</span>
<ul>
  <li>{{securityData.actionUrl}}</li>
</ul>

<span translate>security.erweiterung</span>
<ul>
  <li>{{securityData.erweiterung}}</li>
</ul>

<span translate>security.kanton</span>
<ul>
  <li>{{securityData.kanton}}</li>
</ul>
